// extracted by mini-css-extract-plugin
export default {"items":"items_items__n4wPE","features":"items_features__6LJ3N"};